module.exports = __webpack_public_path__ + "static/media/deviantart.33667d32.svg";